export enum EtapaEnum {
  CONFIRMACAO_VAGA = 2,
  INSCRICAO = 7,
  ESCOLHA_VAGA = 16
}
